module.exports = "<div ng-if=restrictUi.asInternalFeature()> What is your current setup in regards to [money_flows]? ... i'd like to understand my spending habits better ... i'd like to keep track of how much money I have and where it is located ... i need to report personal income to the authorities ... i need to pay my personal taxes </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/current-setup-money-flows.html
// module id = 1713
// module chunks = 86